"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendPageEnum = exports.ChatType = exports.PageLockType = void 0;
var PageLockType;
(function (PageLockType) {
    PageLockType["GROUP"] = "GROUP";
    PageLockType["PAYWALL"] = "PAYWALL";
    PageLockType["LANGUAGE"] = "LANGUAGE";
    PageLockType["CHAT_COMPLETENESS"] = "CHAT_COMPLETENESS";
})(PageLockType || (exports.PageLockType = PageLockType = {}));
var ChatType;
(function (ChatType) {
    ChatType["AI"] = "AI";
    ChatType["LANDBOT"] = "LANDBOT";
    ChatType["MIXED"] = "MIXED";
})(ChatType || (exports.ChatType = ChatType = {}));
var FrontendPageEnum;
(function (FrontendPageEnum) {
    FrontendPageEnum["CHAT"] = "/chat";
    FrontendPageEnum["JOURNEY"] = "/journey";
})(FrontendPageEnum || (exports.FrontendPageEnum = FrontendPageEnum = {}));
